import styled from 'styled-components';
import constants from '../../../core/constants';

const WhatsappWrapper = styled.div`
  display: flex;
  justify-content: center;
  background-color: #ecf4f9;
  padding-top: 58px;
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  color: var(--text-text01);
  a {
    min-width: 219px;
    background-color: #22aa00;
    padding: 10px 16px 10px 16px;
    font-weight: 900;
    border-radius: 4px;
    color: #fff;
    display: flex;
  }
  a div {
    display: flex;
  }
  div.phones {
    padding-top: 10px;
    text-align: center;
    font-size: 14px;
    line-height: 20px;
  }
  div.phones p:last-child {
    margin-left: 4px;
    font-weight: 900;
    margin-bottom: 8px;
  }
  a div img {
    margin-right: 10px;
  }
  a:focus,
  a:active {
    outline: 0;
  }
  @media (min-width: ${constants.BREAKPOINT_SIZE}px) {
    .phones {
      display: flex;
    }
  }
`;

export { Container, WhatsappWrapper };
